// data/earlyYearsData.js
export const sparkData_v2 = [
  {
    id: "spark",
    title: "Spark Music Champions",
    images: [
      { src: "/images/early_years_1.jpeg", alt: "Workshop participant experimenting with music - Image 1" },
      { src: "/images/early_years_2.jpeg", alt: "Workshop participant playing instruments - Image 2" },
      { src: "/images/early_years_3.jpeg", alt: "Workshop participant experimenting with music - Image 1" },
      { src: "/images/spark_v2_1.jpg", alt: "Workshop participant experimenting with music - Image 1" },
      { src: "/images/spark_v2_2.jpg", alt: "Workshop participant playing instruments - Image 2" },
      
      // { src: "/images/spark_v2_3.jpg", alt: "Workshop participant experimenting with music - Image 3" },
      // { src: "/images/spark_v2_4.jpg", alt: "Workshop participant playing instruments - Image 4" },
      { src: "/images/spark_v2_5.jpg", alt: "Children engaging in music activities - Image 5" },
    ],
    intro: (
      <p className="mb-0 text-justify">
        Through the Spark Music Champions programme, I was paired with an early years practitioner at
        Eyres Monsell Children, Young People and Family Centre. The project linked musicians with early
        years staff in a live setting, giving us space to grow our confidence and skills through shared
        training, mentoring, and hands-on exploration.
      </p>
    ),
    full: (
      <>
        <p className="mb-4 text-justify">
          Through the Spark Music Champions programme, I was paired with an early years practitioner at
          Eyres Monsell Children, Young People and Family Centre. The project linked musicians with early
          years staff in a live setting, giving us space to grow our confidence and skills through shared
          training, mentoring, and hands-on exploration.
        </p>

        <p className="mb-4 text-justify">
          We spent time each week playing with sound and music alongside children and families over a period
          of up to 15 weeks. The learning came through practice, observation, and reflection in real early
          years spaces.
        </p>

        <p className="mb-4 text-justify">
          A big part of my approach was working in smaller groups. This helped me build real musical
          connections with children and parents. These close moments opened up trust and play, and over time
          we shaped rich sound worlds together. Families joined in by using rhythm, voice, movement, and
          natural sounds, exploring music as something we make together rather than something performed at them.
        </p>

        <p className="mb-4 text-justify">
          Sessions usually started with an open invitation to play, using resources like parachutes and sponges
          to support sensory exploration and early schemas. From there we moved into music-making with acoustic
          instruments and simple digital effects. Each workshop closed with a sound bed I created for the group,
          blending natural sounds, nursery rhymes, and quiet moments to support imagination and reflection.
        </p>

        <p className="mb-4 text-justify">
          Through this work, I’ve gained a deeper understanding of how music supports early development. It
          offers a creative outlet and a way for children and families to connect, communicate, and grow in
          confidence. My practice is rooted in curiosity, culture, improvisation, and the belief that music is
          for everyone, whatever their age or experience.
        </p>

        <p className="mb-0 text-justify">
          I’m keen to bring this approach into more early years settings, nurseries, festivals, and creative
          family spaces.
        </p>
      </>
    ),
  },

  {
    id: "small-wonders",
    title: "Small Wonders",
    images: [
      { src: "/images/early_years_4.jpeg", alt: "Workshop participant experimenting with music - Image 3" },
      { src: "/images/early_years_5.jpeg", alt: "Workshop participant playing instruments - Image 4" },
      { src: "/images/spark_v2_3.jpg", alt: "Workshop participant experimenting with music - Image 3" },
      { src: "/images/spark_v2_4.jpg", alt: "Workshop participant playing instruments - Image 4" }
    ],
    intro: (
      <p className="mb-0 text-justify">
        Small Wonders felt like a natural next step. It offered creative play and storytelling sessions for
        young children aged 0 to 4 and their families. I was paired with another artist, Chris Sylla, who shared
        similar values but worked in a different way. That mix helped us build something rich together.
      </p>
    ),
    full: (
      <>
        <p className="mb-4 text-justify">
          Small Wonders felt like a natural next step. It offered creative play and storytelling sessions for
          young children aged 0 to 4 and their families. I was paired with another artist, Chris Sylla, who shared
          similar values but worked in a different way. That mix helped us build something rich together.
        </p>

        <p className="mb-4 text-justify">
          Through this process we developed <em>The Chief and the Frogs</em>, a story about a chief who sends the frogs
          away because they are too loud. Once the frogs leave, mosquitoes take over the village. The chief then sends
          the mosquitoes away, but soon realises that insects play an important role in the natural world…
        </p>

        <p className="mb-4 text-justify">
          The chief understands his mistake and invites the frogs and the insects to return. The story offered a simple
          way for children and families to explore sound, listening, and care for the natural world. It also echoed the
          experiences of many immigrants…
        </p>

        <p className="mb-0 text-justify">
          The story is still in its research and development phase. We’re hoping to secure funding to grow it into a
          theatre and live performance piece for children and their families.
        </p>
      </>
    ),
  },
];
